/*=====================================
    折讓發票列表

    Author: Gray
    createtime: 2018 / 01 / 10
=====================================*/

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { parse } from 'qs';
import filter from 'lodash/filter';
import actionCreators from 'actions/creators';
import classNames from "classnames";
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {formatDate, parseDate} from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';
import CupoyRouter from "components/commons/router/CupoyRouter";
import PagedList from 'components/commons/PagedList';
import AllowanceListHeader from './AllowanceListHeader';
import AllowanceListItem from './AllowanceListItem';


class AllowanceListView extends Component {

    // ------------------------------
    // constructor
    // ------------------------------
    constructor(props) {

        super(props);

        this.state = {
            page: 1,
            startDay: '',
            endDay: '',
            isFilterTime: false,
        };

        this.toggleIsFilterTime = this.toggleIsFilterTime.bind(this);
        this.onDaySelectChange = this.onDaySelectChange.bind(this);
        this.onFilterChange = this.onFilterChange.bind(this);
        this.renderCustomDayPickerOverlay = this.renderCustomDayPickerOverlay.bind(this);
    }

    // ------------------------------
    // componentDidMount
    // ------------------------------
    componentDidMount() {

        this.init(this.props);
    }

    // ------------------------------
    // componentWillReceiveProps
    // ------------------------------
    componentWillReceiveProps(nextProps) {

        this.init(nextProps);
    }

    // ------------------------------
    // init
    // ------------------------------
    init(props) {

        if (!props.match) {
            return;
        }

        const page = props.match.params.page;
        const location = props.location;
        var startDay = this.state.startDay;
        var endDay = this.state.endDay;
        var isFilterTime = false;
        var isChange = false;

        if(location && location.search) {
            const querys = parse(location.search.substr(1));

            var starttime = parseInt(querys.starttime, 10);
            var endtime = parseInt(querys.endtime, 10);
            var old_starttime = startDay ? new Date(startDay).getTime() : undefined;
            var old_endtime = endDay ? new Date(startDay).getTime() : undefined;

            if(starttime !== old_starttime) {
                startDay = starttime > 0 ? new Date(starttime) : undefined;
                isChange = true;
            }

            if(endtime !== old_endtime) {
                endDay = endtime > 0 ? new Date(endtime) : undefined;
                isChange = true;
            }

            isFilterTime = starttime || endtime;
        }

        isChange = isChange || this.state.page !== page;

        if (!isChange) {
            return;
        }

        this.setState({
            page: page,
            isFilterTime: isFilterTime,
            startDay: startDay,
            endDay: endDay,
        });
    }

    // ------------------------------
    // 切換過濾時間
    // ------------------------------
    toggleIsFilterTime(isFilterTime) {

        this.setState({
            isFilterTime: isFilterTime,
        }, () => {
            this.onFilterChange();
        })
    }

    // ------------------------------
    // 時間變動
    // ------------------------------
    onDaySelectChange(selectedDay, modifiers, statekey) {

        this.setState({
            [statekey]: selectedDay,
            isFilterTime: true,
        }, () => {
            this.onFilterChange();
        });
    }

    // ------------------------------
    // 任何過濾條件變動
    // ------------------------------
    onFilterChange() {

        const {
            startDay,
            endDay,
            isFilterTime,
        } = this.state;

        var querys = {};

        if(isFilterTime) {

            var new_startDay = new Date(startDay);
            var new_endDay = new Date(endDay);


            if(!isNaN(new_startDay)) {
                querys.starttime = new_startDay.getTime();
            }

            if(!isNaN(new_endDay)) {
                querys.endtime = new_endDay.getTime();
            }
        }

        const statename = CupoyRouter.STATES.ALLOWANCE_LIST;
        const params = {
            page: 1,
        };

        this.props.webActions.cupoyStateGo(statename, params, querys);
    }

    // ------------------------------
    // 將 DatePicker style改為absolute
    // ------------------------------
    renderCustomDayPickerOverlay({ classNames, selectedDay, children }) {

        return (
            <div className={classNames.overlayWrapper} style={{ position: 'absolute', lineHeight: 'normal' }}>
                <div className={classNames.overlay}>
                    {children}
                </div>
            </div>
        );
    }

    // ------------------------------
    // render filter區塊
    // ------------------------------
    renderFilterContent(querys) {

        const {
            isFilterTime,
            startDay,
            endDay,
        } = this.state;

        const startDayValue = startDay ? formatDate(startDay, 'YYYY/MM/DD') : '';
        const endDayValue = endDay ? formatDate(endDay, 'YYYY/MM/DD') : '';

        return (
            <div className="form">
                <table className="form-table">
                    <tbody>
                        <tr className="form-row">
                            <td className="form-col label-text">折讓時間</td>
                            <td className="form-col">
                                <div 
                                    className={classNames("button button-outline", {
                                       'selected': !isFilterTime
                                    })}
                                    onClick={() => this.toggleIsFilterTime(false)}
                                >
                                    不限
                                </div>
                                <div 
                                    className={classNames("button button-outline", {
                                       'selected': isFilterTime
                                    })}
                                    onClick={() => this.toggleIsFilterTime(true)}
                                >
                                    指定區間
                                </div>
                                <DayPickerInput
                                    overlayComponent={this.renderCustomDayPickerOverlay}
                                    onDayChange={(selectedDay, modifiers) => this.onDaySelectChange(selectedDay, modifiers, 'startDay')}
                                    formatDate={formatDate}
                                    parseDate={parseDate}
                                    format="YYYY/MM/DD"
                                    value={startDayValue}
                                    dayPickerProps={{
                                        selectedDays: startDay,
                                    }}
                                    placeholder="起"
                                />
                                <span className="line"></span>
                                <DayPickerInput
                                    overlayComponent={this.renderCustomDayPickerOverlay}
                                    onDayChange={(selectedDay, modifiers) => this.onDaySelectChange(selectedDay, modifiers, 'endDay')}
                                    formatDate={formatDate}
                                    parseDate={parseDate}
                                    format="YYYY/MM/DD"
                                    value={endDayValue}
                                    dayPickerProps={{
                                        selectedDays: endDay,
                                    }}
                                    placeholder="訖"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

    // ------------------------------
    // render
    // ------------------------------
    render() {

        const { page } = this.state;
        const { pageLen, totalCount, location } = this.props;
        const num_page = Number(page);
        var querys = {};

        if(location && location.search) {
            querys = parse(location.search.substr(1));
        }

        return (
            <div id="allowance">
                <div className="header-bar mix">
                    <h1 className="title">折讓單列表</h1>

                </div>
                <PagedList
                    page={num_page}
                    pageLen={pageLen}
                    totalCount={totalCount}
                    colspan={8}
                    querys={querys}
                    getListItemFrom={(start) => {
                        return this.props.allowanceActions.getAllowanceList({
                            start: start,
                            starttime: querys.starttime,
                            endtime: querys.endtime,
                        });
                    }}
                    pageStateName={CupoyRouter.STATES.ALLOWANCE_LIST}
                    getItemsInRanage={(start, end) => {
                        return filter(this.props.allowanceList, (item, index) => {
                            return Number(index) >= start && Number(index) < (end);
                        });
                    }}
                    renderItemHeaderRow={(item, index) => {
                        return <AllowanceListHeader />;
                    }}
                    renderItemRow={(item, index, start) => {
                        return <AllowanceListItem
                            key={index}
                            item={this.props.allowances[item]}
                            start={start}
                            index={index}
                        />;
                    }}
                    renderFilterContent={() => {
                        return this.renderFilterContent(querys);
                    }}
                />
            </div>
        );
    }
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function (state) {
    return {
        allowanceList: state.allowance.allowanceList,
        allowances: state.allowance.allowances,
        pageLen: state.allowance.pageLen,
        totalCount: state.allowance.totalCount
    };
};

/*--------------------------
    Reducer Action
--------------------------*/
const mapActionToProps = function (dispatch) {
    return {
        allowanceActions: bindActionCreators(actionCreators.allowanceActionCreators, dispatch),
        webActions: bindActionCreators(actionCreators.webActionCreators, dispatch), 
    };
};

/*--------------------------
    export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
    withRef: true
})(AllowanceListView);


// WEBPACK FOOTER //
// ./src/components/allowance/AllowanceListView.jsx